import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import DeleteModal from "../components/delete_modal";
import DeleteIcon from "@mui/icons-material/Delete";
import { ShowBranchesModel } from "../components/showBranchesModal";
import {
  selectnodess,
  selectRootId,
} from "../redux/nodesSlice";
import OrganizationModal from "../components/OrganizationModal";
import { toast } from "react-toastify";
import { selectgroups } from "../redux/businessSlice";
import { selectAdmin, selectDevice } from "../redux/adminSlice";
import { orgwarndata } from "../redux/websocketSlice";
import WarningModal from "../components/WarningModal";
import { useDeleteOrganizationMutation, useUpdateOrganizationMutation } from "../redux/organizationApi";
import TableMuiCustom from "../mui/TableMuiCustom";
import { AddChildNode } from "../components/addChildNodeModel";


// import { selectgroups } from "../redux/businessSlice";
function MainOraganizations() {
  const [loading, setLoading] = useState(true);
   const deviceId = useSelector(selectDevice);
  const admin = useSelector(selectAdmin);
  const warndata=useSelector(orgwarndata);
  const [singledata, setSingleData] = useState()
  const [detail, setDetail] = useState(false);
  const allorganization = useSelector(selectnodess) || [];
  const rootId = useSelector(selectRootId);
  const [rootOrganizations, setRootOrganizations] = useState([]);
  const [sharedata, setSharedata] = useState(0);
  const [showBranch, setshowBranch] = useState(false);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const groups = useSelector(selectgroups);
  const groupfilter = (id) => {
    if (!Array.isArray(groups)) {
      return "";
    }
    const data = groups.find((item) => item._id === id.toString())
    //// console.log(data, "this is id data")

    // //// console.log(data,"this is group data for groupname");

    return data?.businessNature || "";
  }
  const [errors, setErrors] = useState({
    general: {}, // For general fields
    shareholders: [], // For shareholders
    // directors: [], 
  });
  const [nodeData, setNodeData] = useState({
    location: {
      name: "", address: "", lat: "", lng: "", countryName: ""
    },
    PercentageOfShares: "",
    companyName: "",
    totalNoOfShares: 0,
    directors: [],
    shareHolders: []

  });
  const [nodeid, setnodeid] = useState("");
  const [node, setnode] = useState({});
  const [node1, setnode1] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteOrganization, { isLoading: isDeleting }] =
    useDeleteOrganizationMutation();
  const [updateOrganization, { isLoading: isUpdating }] =
    useUpdateOrganizationMutation();


  const deleteData = async () => {
    try {
      setOpen(false);
      const payload = showBranch
        ? { id: node.nodeId, isRoot: false }
        : { id: nodeid, isRoot: true };
      await deleteOrganization(payload).unwrap();
      toast.success("Node deleted successfully");
    } catch (error) {
      toast.error(
        error?.data?.message || error?.error || "Failed to delete organization"
      );
    }
  };

  useEffect(() => {
    setLoading(false);
  }, [allorganization?.length]);
  const handleClose = () => {
    setOpen(false);
    dispatch({ type: "alertremove", payload:{
      id:nodeData?._id ,
      message:"Another users also edit this business group"
    } })
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNodeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };



  const handelDirector = (index, name) => {
    const newNames = [...nodeData.directors];
    newNames[index] = name;
    setNodeData((prev) => ({ ...prev, directors: newNames }));
  };

  const handleAddDirector = () => {
    setNodeData((prev) => ({ ...prev, directors: [...prev.directors, ""] }));
  };



  const handleTotalSharesChange = (e) => {
    const { value } = e.target;
    const totalShares = parseFloat(value);

    // Update state and recalculate percentages
    setNodeData((prevData) => {
      const updatedShareHolders = prevData.shareHolders?.map((sh) => ({
        ...sh,
        PercentageOfShares:
          totalShares > 0 ? (sh.numberSharesOwned / totalShares) * 100 : 0,
      }));

      return {
        ...prevData,
        totalNoOfShares: totalShares,
        shareHolders: updatedShareHolders,
      };
    });
  };

  const requiredFields = [
    { key: "location", message: "Location is required" },
    { key: "companyName", message: "Company Name is required" },
    { key: "totalNoOfShares", message: "Total No of Shares is required" },
    { key: "Incorporationdate", message: "Incorporation date is required" },
    { key: "CompanyRegistrationNumber", message: "Company Registration Number is required" },
    // { key: "Remarks", message: "Remarks is required" },
  
    { key: "BusinessGroup", message: "Business Group is required" },
  ];


  const validateInput = () => {
    const errorObject = { general: {}, shareholders: [], directors: [] };

    requiredFields?.forEach((field) => {
      if (!nodeData[field.key] || (field.key === "location" && (
        !nodeData.location.name ||
        !nodeData.location.address ||
        nodeData.location.lat === null ||
        nodeData.location.lng === null
      ))) {
        errorObject.general[field.key] = field.message;
      }
    });

    nodeData.shareHolders?.forEach((shareholder, index) => {
      const shareholderErrors = {};
      if (!shareholder.childId) {
        shareholderErrors.childId = "Shareholder is required";
      }
      if (!shareholder.numberSharesOwned) {
        shareholderErrors.numberSharesOwned = "Number of Shares is required";
      }
      const selectedParents = nodeData.shareHolders?.map((sh) => sh.childId);
      if (selectedParents.indexOf(shareholder.childId) !== index) {
        shareholderErrors.childId = "Shareholder is already added";
      }
      errorObject.shareholders[index] = shareholderErrors;
    });

    // nodeData.directors?.forEach((director, index) => {
    //   if (!director) {
    //     errorObject.directors[index] = "Director Name is required";
    //   }
    // });

    setErrors(errorObject);
    return (
      Object.keys(errorObject.general).length === 0 &&
      errorObject.shareholders.every((e) => Object.keys(e).length === 0) 
      // errorObject.directors.every((e) => !e)
    );
  };

  const handleSubmit = async () => {
    if (!validateInput()) {
      // alert("Please fix the errors in the form.");
      return;
    }
    try {
      setOpen(false);
      await updateOrganization({
        id: nodeData.nodeId,
        data: nodeData,
      }).unwrap();
      toast.success("Company Updated successfully");
    } catch (error) {
      console.error("Error updating node:", error);
      toast.error("Failed to update node");
    }
  };

  useEffect(() => {
    const currentRoot = Array.isArray(allorganization) && allorganization?.filter((org) => org.isRoot === true);
    // console.log(currentRoot,"this is root")
    setRootOrganizations(currentRoot||[]);
  }, [allorganization, dispatch]);


  const enrichedOrganizations = rootOrganizations?.map((org, index) => ({
    ...org,
    data: {
      ...org.data,
      index: index + 1,
      directors: org.data.directors ? org.data.directors.join(",") : "",
      directorsLength: org.data.directors ? org.data.directors.length : 0,
    },
  }));

  return (
    <>
      <div>
        <div className="add-new  d-flex align-items-end  justify-content-end "></div>
        <div className="p-sm-3">
          <div>
            <h3 className="fw-bold">Ultimate Holding Company</h3>
            <div className="row mb-md-0 mb-2">
              <div className="col-md-6">

              </div>
              {!rootId  && (
                <div className="col-md-6 d-flex justify-content-end">
                  <span>
                    <Link
                      to={"/admin/dropdown/root"}
                      className="btn text-white"
                      style={{ backgroundColor: "#003B93", minWidth: "150px" }}
                    >
                      <FaPlus /> Add New
                    </Link>
                  </span>
                </div>
              )}
            </div>
            {['viewSpecificCompanies', 'viewAllOrganization', 'viewCountryBusinessTypeOrganization', 'viewBusinessTypeOrganization'].some(permission => admin?.permissions?.[permission]) && 
            <div className="w-100" style={{ position: 'relative', minHeight: '400px' }}>
              {(loading || isUpdating || isDeleting) ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                  <CircularProgress size={50} sx={{ color: '#003B93' }} />
                </Box>
              ) : (
                <TableMuiCustom
                styleTableTh={{ fontWeight: "bold" }}
                styleTableContainer={{ minWidth: "800px" }}
                TableHead={{
                  borderRadius: "10px",
                  color: "black",
                  fontWeight: "bold",
                }}
                styleTableThead={{
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "bold",
                }}
                th={{
                  index: "ID",
                  companyName: "Company Name",
                  Businessgroup: "Business Group",
                  location: "Location",
                  totalNoOfShares: "Total Issued Shares",
                  // directorsLength: "Directors",
                  editBtn: `${admin?.permissions.editOrganization ? "Edit" : ""}`,
                  treeView: "Tree View",
                  branchView: "Branches",
                  deleteBtn: `${admin?.permissions.deleteOrganization ? "Delete" : ""}`,
                }}
                td={enrichedOrganizations}
                customFields={[
                  {
                    name: "companyName",
                    data: (value, row) => (
                      <Box className="d-flex justify-content-between align-items-center" style={{ cursor: 'pointer' }} onClick={() => {
                        // console.log("this is row data",row)
                        const data=rootOrganizations?.find((item)=>item.id===row.nodeId)
                        setSingleData(data?.data)
                        


                        setDetail(true)

                      }}>
                        {row?.companyName}
                      </Box>
                    ),
                  },
                  {
                    name: "Businessgroup",
                    data: (value, row) => (
                      <Box className="d-flex justify-content-center align-items-center" style={{ cursor: 'pointer' }} >
                        {groupfilter(row?.BusinessGroup)}
                      </Box>
                    ),
                  },
                  {
                    name: "totalNoOfShares",
                    data: (value, row) => (
                      <Box className="d-flex justify-content-between align-items-center">
                        {row.totalNoOfShares.toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </Box>
                    ),
                  },
                  {
                    name: `${admin?.permissions.editOrganization ? "editBtn" : ""}`,
                    data: (value, row) => (
                      <Box className="d-flex justify-content-between align-items-center">
                        <button
                          onClick={() => {
                            // //// console.log(row);
                            setNodeData({
                              ...row,
                              shareHolders: row.shareHolders,
                              directors: row.directors.split(",") || [],
                            });
                            setOpen(true);
                            dispatch({ type: "alertchange", payload:{
                              id:row?._id,
                              message:"Another users also edit this business group"
                            } })
                          }}
                          style={{ backgroundColor: "#003B93", color: "white" }}
                          className="btn"
                        >
                          Edit
                        </button>
                      </Box>
                    ),
                  },
                  {
                    name: "location",
                    data: (value, row) => (
                      <Box className="d-flex justify-content-between align-items-center">

                        {row.location.address}
                      </Box>
                    ),
                  },
                  {
                    name: "treeView",
                    data: () => (
                      <Box className="d-flex justify-content-between align-items-center">
                        <button
                          onClick={() => {
                            navigate("/admin/Organisational-Chart");
                          }}
                          style={{ backgroundColor: "#003B93", color: "white" }}
                          className="btn"
                        >
                          Tree View
                        </button>
                      </Box>
                    ),
                  },
                  {
                    name: "branchView",
                    data: (value, row) => (
                      <Box className="d-flex justify-content-between align-items-center">
                        <button
                          onClick={() => {
                            setshowBranch(true);
                            setnode1(row)
                          }}
                          style={{ backgroundColor: "#003B93", color: "white" }}
                          className="btn"
                        >
                          Branches
                        </button>
                      </Box>
                    ),
                  },
                  {
                    name: `${admin?.permissions.deleteOrganization ? "deleteBtn" : ""}`,
                    data: (value, row) => (
                      <Box className="d-flex justify-content-between align-items-center">
                        <DeleteIcon
                          style={{
                            fontSize: "30px",
                            color: "#1976d2",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            console.log(row,"this is row data");
                            setnodeid(row.nodeId);
                            setOpenDeleteModal(true);
                            setnode(row)
                          }}
                        />
                      </Box>
                    ),
                  },
                ]}
              />
              )}
            </div> }
          </div>
        </div>
        {open && (
          <AddChildNode
            origin={"root"}
            nodeData={nodeData}
            handleClose={handleClose}
            open={open}
            handleChange={handleChange}
            errors={errors}
            setErrors={setErrors}
            handleSubmit={handleSubmit}
            handelDirector={handelDirector}
            handleAddDirector={handleAddDirector}
            handleTotalSharesChange={handleTotalSharesChange}
            sharedata={sharedata}
            setSharedata={setSharedata}
            setNodeData={setNodeData}
          />
        )}
                      {(open && nodeData?._id === warndata?.objId && warndata?.users?.filter((item) => item !== admin?._id+"-"+deviceId).length > 0) && <WarningModal setOpen={setOpen} setNodeData={setNodeData} usersInfo={warndata?.usersInfo || []}  users={warndata?.users} nodeId={warndata?.objId}/>}

      </div>
      <DeleteModal setOpenDeleteModal={setOpenDeleteModal} openDeleteModal={openDeleteModal} deleteData={deleteData} setshowBranch={setshowBranch} data={node}/>
      {singledata && detail && <OrganizationModal open={detail} onClose={() => { setDetail(false) }} organization={singledata}  allorg={allorganization} />}
      <ShowBranchesModel setdatafordelete={() => { }} open={showBranch} setOpenDeleteModal={setOpenDeleteModal} setDeleteopen={() => { }} setNodeData={setNodeData} setOpen={setOpen} handleClose={setshowBranch} node={node1} setnode={setnode1} setnodefordelete={setnode} />
    </>
  );
}

export default MainOraganizations;